
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin-hub",
      function () {
        return require("private-next-pages/admin-hub.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin-hub"])
      });
    }
  